module.exports = __webpack_public_path__ + "img/volont.1dca2cac.jpg";